const state = {
  customers:{}
}

export default state
